import axios from "axios";
import config from "../config";

const axiosInstance = axios.create({
  baseURL: config.appUrl,
  headers: {
    Accept:
      "application/json, image/png, image/jpeg, image/jpg, video/mp4, application/pdf, multipart/form-data",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
